import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { faComments, faPaperPlane } from '@fortawesome/free-regular-svg-icons';
import {
  faArrowRight,
  faLifeRing,
  faMarker,
  faQuoteLeft,
  faStarHalfAlt,
} from '@fortawesome/free-solid-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';

import { AuthProvider } from '../shared/context/Auth';
import { ToastProvider } from '../shared/context/Toast';
import Home from './pages/Home';
import { HOME } from './shared/constants/routes';

library.add(
  faArrowRight,
  faComments,
  faLifeRing,
  faMarker,
  faPaperPlane,
  faQuoteLeft,
  faStarHalfAlt
);

const Marketing = () => (
  <AuthProvider entityType="user">
    <ToastProvider>
      <Router>
        <Routes>
          <Route exact path={HOME} element={<Home />} />
        </Routes>
      </Router>
    </ToastProvider>
  </AuthProvider>
);

export default Marketing;
